/**
 * @file internalMigrations.ts
 *
 * The library's own migration chain, keyed by as-components version and run
 * before the app's chain on every project load. See docs/internalMigrations.md.
 *
 * Entries use the same MigrationMap shape apps register with setMigrations(),
 * so there is one set of semantics. The key is the as-components version that
 * introduced the change, matched against `metadata.componentsVersion` on the
 * saved file. A file with no stamp predates it and runs the whole chain.
 *
 * Deletions here should be written as mappings (`{ key: null }`) rather than
 * transforms. Only mapping deletions are reported to app `pending` transforms
 * through their `droppedKeys` argument.
 */

import type { MigrationMap } from './projectManagement.ts';

export const INTERNAL_MIGRATIONS: MigrationMap = {
  // Empty. The stamp is what matters today: a file saved now records the
  // library version that wrote it, so a later change has something to key on.
};
